import { Autocomplete } from '@react-google-maps/api';
import React, { useCallback, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { GoogleMapContext } from '../../contexts';
import { FormInput } from '../form/FormInput';

export const GoogleSearchBox = (props) => {
  const { onChange, value } = props;
  const { t } = useTranslation();
  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);
  const { isLoaded } = useContext(GoogleMapContext);

  const onLoad = useCallback((autocomplete) => {
    autocompleteRef.current = autocomplete;
  }, []);

  const onPlaceChanged = useCallback(() => {
    if (!autocompleteRef.current) return;

    try {
      const place = autocompleteRef.current.getPlace();

      if (place?.formatted_address) {
        const formattedAddress = place.formatted_address;
        onChange(formattedAddress);
      } else if (inputRef.current?.value) {
        onChange(inputRef.current.value);
      }
    } catch (error) {
      if (inputRef.current?.value) {
        onChange(inputRef.current.value);
      }
    }
  }, []);

  const handleInputChange = useCallback((e) => {
    onChange(e.target.value);
  }, []);

  if (!isLoaded) {
    return null;
  }

  return (
    <div style={{ position: 'relative', zIndex: 9999 }}>
      <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
        <FormInput
          type='text'
          ref={inputRef}
          value={value}
          onChange={handleInputChange}
          placeholder={t('ADDRESS_PLACEHOLDER')}
        />
      </Autocomplete>
    </div>
  );
};

export default React.memo(GoogleSearchBox);
